import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { mediaPath } from "@/lib/media";

/**
 * Optimized raster with explicit dimensions (reduces CLS).
 * Pass `priority` + `fetchPriority="high"` for LCP images only.
 */
export default function SiteImage(t0) {
  const $ = _c(28);
  let alt;
  let fill;
  let height;
  let rest;
  let sizes;
  let src;
  let t1;
  let t2;
  let width;
  if ($[0] !== t0) {
    ({
      src,
      alt,
      width,
      height,
      fill,
      sizes,
      priority: t1,
      className: t2,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = fill;
    $[3] = height;
    $[4] = rest;
    $[5] = sizes;
    $[6] = src;
    $[7] = t1;
    $[8] = t2;
    $[9] = width;
  } else {
    alt = $[1];
    fill = $[2];
    height = $[3];
    rest = $[4];
    sizes = $[5];
    src = $[6];
    t1 = $[7];
    t2 = $[8];
    width = $[9];
  }
  const priority = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "" : t2;
  let t3;
  if ($[10] !== src) {
    t3 = mediaPath(src);
    $[10] = src;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const path = t3;
  if (fill) {
    const t4 = alt || "";
    const t5 = sizes ?? "100vw";
    let t6;
    if ($[12] !== className || $[13] !== path || $[14] !== priority || $[15] !== rest || $[16] !== t4 || $[17] !== t5) {
      t6 = <Image src={path} alt={t4} fill={true} sizes={t5} priority={priority} className={className} {...rest} />;
      $[12] = className;
      $[13] = path;
      $[14] = priority;
      $[15] = rest;
      $[16] = t4;
      $[17] = t5;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    return t6;
  }
  const t4 = alt || "";
  let t5;
  if ($[19] !== className || $[20] !== height || $[21] !== path || $[22] !== priority || $[23] !== rest || $[24] !== sizes || $[25] !== t4 || $[26] !== width) {
    t5 = <Image src={path} alt={t4} width={width} height={height} sizes={sizes} priority={priority} className={className} {...rest} />;
    $[19] = className;
    $[20] = height;
    $[21] = path;
    $[22] = priority;
    $[23] = rest;
    $[24] = sizes;
    $[25] = t4;
    $[26] = width;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  return t5;
}